import { School, Centre, Country, Product } from "app/shared/model";
import { EditPricelistResponse } from "app/shared/model/EditPricelist";
import { FormError } from "app/shared/model/Form";
import { PricingYearId } from "app/shared/model/PricingYearId";
import { SaveState } from "app/shared/ui/GenericSaveAndBackButton";

export enum ActionType {
    PageLaded = 'Pricelist/PageLoaded',

    ChangeSelectedProductType = 'Pricelist/ChangeSelectedProductType',
    ChangeSelectedPricingYear = 'Pricelist/ChangeSelectedPricingYear',
    ChangeSelectedCentre = 'Pricelist/ChangeSelectedCentre',

    LoadPricelist = 'Pricelist/LoadPricelist',
    LoadDraftPricelist = 'Pricelist/LoadDraftPricelist',
    UpdateDraftPricelistItem = 'Pricelist/UpdateDraftPricelistItem',
    SetFormState = 'Pricelist/SetFormState',
    SetIsLoading = 'Pricelist/SetIsLoading',
    SetFormErrors = 'Pricelist/SetFormErrors'
}

export type ChangeSelectedCentre = {
    type: ActionType.ChangeSelectedCentre,
    selectedCentreCode: string
};

export type PageLoadedEvent = {
    type: ActionType.PageLaded
    
    schools: School[],
    centres: Centre[],
    countries: Country[],
    products: Product[],
    pricingYears: PricingYearId[],

    selectedProductType: string,

    formState: SaveState,
    isLoading: boolean,
    formErrors: FormError[],
    errorMessage: string,
}

export type PageLoadedData = {
    schools: School[],
    centres: Centre[],
    countries: Country[],
    products: Product[],
    pricingYears: PricingYearId[],

    selectedProductType: string,
}

export type ChangeSelectedProductType = {
    type: ActionType.ChangeSelectedProductType,
    selectedProductType: string
}

export type ChangeSelectedPricingYear = {
    type: ActionType.ChangeSelectedPricingYear,
    selectedPricingYearId: number
}


export type LoadPricelist = {
    type: ActionType.LoadPricelist,
    pricelist: EditPricelistResponse[]
}

export type LoadDraftPricelist = {
    type: ActionType.LoadDraftPricelist,
    draftPricelist: EditPricelistResponse[]
}

export type UpdateDraftPricelistItem = {
    type: ActionType.UpdateDraftPricelistItem,
    pricelistItem: EditPricelistResponse,
    pricelistIndex: number
}

export type SetFormState = {
    type: ActionType.SetFormState,
    formState: SaveState,
    errorMessage: string
}

export type SetIsLoading = {
    type: ActionType.SetIsLoading,
    isLoading: boolean
}

export type formErrors = {
    type: ActionType.SetFormErrors,
    formErrors: FormError[]
}

export type Action =
    | PageLoadedEvent
    | ChangeSelectedProductType
    | ChangeSelectedPricingYear
    | ChangeSelectedCentre
    | LoadPricelist
    | LoadDraftPricelist
    | UpdateDraftPricelistItem
    | SetFormState
    | SetIsLoading
    | formErrors;

